<template>
  <div>
    <es-loader
      v-if="loading"
      style="margin: 25rem"
      size="5x"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="Batch not found."
    />
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title">
                    Batch Profile
                  </div>
                  <div class="header-subtitle">
                    Contains one or many records.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ batch.id }}
                  </div>
                  <div class="column-subtitle">
                    Batch ID
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    <div>
                      {{ batch.submissionTypeCode }}
                    </div>
                    <div
                      v-if="batch.submissionTypeCode === 'FILE'"
                      class="max-width"
                      style="margin: auto"
                    >
                      ({{ batch.fileName }})
                    </div>
                  </div>
                  <div class="column-subtitle">
                    Submission Type
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ formatDateTime(batch.createdDate) }}
                  </div>
                  <div class="column-subtitle">
                    Process Info
                  </div>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="column-content">
                  <div>
                    <pid-status-info-icon
                      :header="true"
                      :processStatus="batch.status"
                    />
                  </div>
                  <div class="column-subtitle">
                    Status
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-profile-header>
        <div class="tabs-container no-bottom-border">
          <es-tabs :tabs="tabs" ref="tabs"></es-tabs>
        </div>
      </div>
      <router-view
        :batch="batch"
        :restarting="restarting"
        @refreshTheBatch="loadBatch"
        @restartTheBatch="restartBatch"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import PidStatusInfoIcon from '@/components/PidStatusInfoIcon.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import EsTabs from '../../../components/EsTabs.vue';

export default {
  mixins: [
    BreadcrumbsManager,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
    PidStatusInfoIcon,
    EsTabs,
  },
  props: [
    'batchId',
  ],
  data() {
    return {
      batch: {},
      loading: false,
      loadingError: false,
      restarting: false,
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      {
        name: this.isRejected ? 'PIRejectedBatchInfoDetails' : 'PIBatchInfoDetails',
        label: 'DETAILS',
        ariaLabel: 'Batch Profile Details',
      },
      ...(this.hasModule('PRSID:DWNLD:DOWNLOAD') && [{
        name: this.isRejected ? 'PIRejectedBatchInfoDownload' : 'PIBatchInfoDownload',
        label: 'DOWNLOAD',
        ariaLabel: 'Batch Profile Download',
      }]),
    ];
    this.loadPersonTypes();
    this.loadBatch();
  },
  mounted() {
    this.setBreadcrumbs();
  },
  computed: {
    isRejected() {
      if (this.$route.path.includes('rejected')) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mm A');
    },
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'personId' } },
        { text: 'Processing Information ', to: {} },
      ]);
    },
    async loadBatch() {
      try {
        this.loading = true;
        this.loadingError = false;
        let res = null;
        if (this.isRejected) {
          res = await axios.get(`personid/rejected/${this.batchId}`);
        } else {
          res = await axios.get(`personid/batches/${this.batchId}`);
        }
        this.batch = res.data;
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    async restartBatch() {
      try {
        this.restarting = true;
        this.loadingError = false;
        const res = await axios.put(`personid/batches/${this.batchId}`);
        this.batch = res.data;
        this.showNotification('success', ['The batch has been restarted successfully']);
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
        this.loadingError = true;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .header-title
    color: #000 !important
    font-weight: 700 !important
  .header-subtitle
    color: #6c757d
  .max-width
    font-weight: 400 !important
    max-width: 20ch
</style>
